module.exports = __webpack_public_path__ + "4fbc15f09bc8f8fe51b9b7d03212e431.pdf";